import React, { FC } from 'react';
import { Info } from './styles';

const InfoIcon: FC = ({ ...rest }) => {
	return <Info {...rest} />;
};

export default InfoIcon;
